import IntentLandingLayout from "@/components/landing/IntentLandingLayout";

export default function AccueilTelephoniqueImmobilier() {
  return (
    <IntentLandingLayout
      canonical="/accueil-telephonique-immobilier"
      title="Accueil téléphonique immobilier pour agence | Immovox"
      description="Accueil téléphonique immobilier : répondez de façon homogène, identifiez chaque demande et transmettez le bon contexte aux équipes de l'agence."
      eyebrow="Accueil téléphonique immobilier"
      h1="Un accueil téléphonique immobilier qui comprend chaque demande."
      lede="Immovox accueille vendeurs, acquéreurs, locataires et propriétaires, identifie leur demande puis transmet le bon contexte à votre équipe."
      serviceType="Accueil téléphonique pour agence immobilière"
      primaryCtaLabel="Tester l'accueil Immovox"
      acquisitionHero={{
        visual: "accueil",
        visualLabel: "Accueil téléphonique immobilier",
        visualTitle: "Le premier échange donne le ton.",
        visualText: "Immovox accueille l'appelant au nom de l'agence, comprend sa demande et prépare la bonne suite.",
        secondaryCtaLabel: "Voir un accueil en situation",
        strip: ["Accueillir au nom de l'agence", "Identifier le besoin sans script rigide", "Orienter avec le bon contexte"],
      }}
      definition={<>L'<strong>accueil téléphonique immobilier</strong> désigne la façon dont une agence prend en charge le premier échange avec vendeurs, acquéreurs, locataires, propriétaires et partenaires : décroché, identification du motif, collecte des informations et orientation vers la bonne suite.</>}
      sections={[
        {
          title: "Un bon accueil téléphonique ne se limite pas à décrocher",
          intro: "Répondre vite est utile, mais la valeur se crée surtout dans la qualité du contexte transmis à l'équipe.",
          bullets: [
            "Se présenter clairement au nom de l'agence.",
            "Identifier ce que souhaite réellement l'appelant.",
            "Éviter de faire répéter les mêmes informations lors du rappel.",
            "Orienter une demande commerciale, locative ou de gestion vers le bon traitement.",
            "Conserver un ton et des règles cohérents d'un appel à l'autre.",
          ],
        },
        {
          title: "Quel accueil selon le type d'appelant ?",
          bullets: [
            "Vendeur : comprendre s'il cherche une estimation, une mise en vente ou simplement une information.",
            "Acquéreur : identifier le bien ou le projet recherché avant le rappel.",
            "Locataire ou candidat : distinguer une annonce, un dossier, une question administrative ou une demande urgente.",
            "Propriétaire : reconnaître une demande de gestion, de location ou de suivi.",
            "Partenaire et prestataire : recueillir le dossier concerné et la raison du contact.",
          ],
        },
        {
          title: "Standardiser l'accueil sans rendre la conversation rigide",
          paragraphs: [
            "Un script téléphonique efficace définit les informations à obtenir, pas une conversation mot pour mot. L'appelant doit pouvoir expliquer son besoin avec ses propres mots.",
            "Immovox utilise des scénarios pour guider l'échange tout en adaptant les questions au motif détecté. L'objectif est d'obtenir un contexte fiable sans transformer l'appel en formulaire vocal interminable.",
          ],
        },
        {
          title: "Que doit contenir le compte rendu après l'appel ?",
          bullets: [
            "Identité et coordonnées communiquées par l'appelant.",
            "Motif principal et éventuel bien ou dossier concerné.",
            "Informations de qualification réellement données pendant l'appel.",
            "Éléments utiles à la priorisation de la demande.",
            "Résumé court permettant à un collaborateur de reprendre l'échange sans repartir de zéro.",
          ],
        },
        {
          title: "Accueil interne, débordement ou externalisation",
          paragraphs: [
            "L'accueil principal peut rester assuré par l'équipe de l'agence. Une couche IA devient utile lorsque le téléphone interrompt les rendez-vous, que plusieurs appels arrivent en même temps ou que l'agence souhaite maintenir une réponse en dehors des heures d'ouverture.",
            "Le renvoi conditionnel permet d'utiliser Immovox comme relais plutôt que comme remplacement systématique de l'accueil existant.",
          ],
        },
      ]}
      faq={[
        { question: "Quel est l'objectif d'un accueil téléphonique en agence immobilière ?", answer: "Comprendre rapidement la demande, recueillir les informations nécessaires et permettre au bon interlocuteur de reprendre le dossier avec du contexte." },
        { question: "Un assistant IA peut-il respecter le discours de l'agence ?", answer: "Oui, dans la limite des règles et informations configurées. Il peut utiliser une présentation, des consignes et des scénarios adaptés à l'agence." },
        { question: "Faut-il confier tous les appels à l'IA ?", answer: "Non. Immovox peut n'intervenir qu'en débordement ou hors horaires grâce au renvoi d'appel." },
        { question: "Comment éviter un accueil trop robotique ?", answer: "En limitant le nombre de questions aux informations réellement utiles et en laissant l'appelant exprimer son besoin en langage naturel." },
        { question: "Accueil téléphonique et permanence téléphonique sont-ils la même chose ?", answer: "L'accueil décrit la qualité et le traitement du premier contact. La permanence désigne surtout l'organisation mise en place pour continuer à répondre lorsque l'équipe habituelle n'est pas disponible." },
      ]}
      related={[
        { to: "/qualification-appels-immobilier", label: "Qualification des appels", description: "Les questions utiles selon vendeur, acquéreur, locataire ou propriétaire." },
        { to: "/permanence-telephonique-immobilier", label: "Permanence téléphonique", description: "Organiser le relais quand l'équipe est indisponible." },
        { to: "/standard-telephonique-immobilier", label: "Standard téléphonique immobilier", description: "Mettre l'accueil et la qualification dans un même dispositif." },
      ]}
      ctaTitle="Améliorer l'accueil téléphonique de votre agence"
      ctaText="Testez un scénario avec vos propres cas d'appel et vérifiez la qualité du contexte transmis à votre équipe."
    />
  );
}
